module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-8.b0f0121f.png";